import { ActionFunctionArgs, redirect } from "react-router-dom";
import { api } from "services/api.service";
import { defaultLocationManagementLocationKind } from "types/locationManagement/locationKind";
import { withActionErrorAlert } from "utils/withActionError";
import { withAuth } from "routes/utils/withAuth";

export const loader = withAuth(async () => {
  return { locationKind: defaultLocationManagementLocationKind };
});

export async function action({ request }: ActionFunctionArgs) {
  const fd = await request.formData();
  const res = await withActionErrorAlert(() =>
    api.request({
      method: "POST",
      url: `/location_management/location_kinds`,
      data: fd,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  );
  if (res?.status === 201) {
    return redirect("/location-kinds");
  }
  return res;
}
